import React from 'react';
import { useClub } from '~/features/club';
import { M200ProfileModule } from '~/lib/data-contract';
import { useTranslation } from '~/shared/utils';
import { useModule } from '~/templates';
import { ButtonLegacy, RawHtml, Text } from '~/shared/components';
import { Spacer } from '~/theme';

export const DeleteUserSection = () => {
    const {
        element: { deleteMembershipSection },
    } = useModule<M200ProfileModule>();
    const { translate } = useTranslation();
    const { toggleDeleteAccountActive } = useClub();
    return (
        <>
            <Text variant="display2" as="h2">
                {translate('club.profile.deleteMembershipHeader')}
            </Text>
            <RawHtml html={deleteMembershipSection} />
            <Spacer space="5" />
            <ButtonLegacy variant="secondary" onClick={() => toggleDeleteAccountActive(true)}>
                {translate('club.deleteAccount.buttonText')}
            </ButtonLegacy>
        </>
    );
};
